import {
  saveCurCard,
  saveCurCity,
  saveCurOrder,
  saveCurOrg,
  saveCurPac,
  saveInvoice,
} from "@/assets/js/cache";
import * as types from "./mutation-types";
import { getUserInfo } from "@/assets/js/api";
import { getCookie } from "@/assets/js/util";

export const saveUser = function ({ commit, state }) {
  return new Promise((resolve, reject) => {
    // 510 未注册 511 未授权 200 正常
    getUserInfo().then((res) => {
      res.data &&
        res.data.user_info &&
        commit(types.SET_USER, res.data.user_info);
      if (res.code === 200) {
        resolve(res);
      } else {
        const redirectUrl = getCookie("_current_url") || window.location.href;
        if (window.location.host.includes("test.")) {
          const pathname = window.location.pathname.split("/wechat")[0];
          window.location.href = `//${
            window.location.host
          }${pathname}/api/authservice/login?redirect=${encodeURIComponent(
            redirectUrl
          )}`;
        } else {
          window.location.href = `//${
            window.location.host
          }/api/authservice/login?redirect=${encodeURIComponent(redirectUrl)}`;
        }
      }
    });
  });
};
export const saveCity = function ({ commit, state }, item) {
  commit(types.SET_CURRENT_CITY, item);
  saveCurCity(item);
};
export const savePac = function ({ commit, state }, item) {
  commit(types.SET_CURRENT_PAC, item);
  saveCurPac(item);
};

export const saveOrg = function ({ commit, state }, item) {
  commit(types.SET_CURRENT_ORG, item);
  saveCurOrg(item);
};

export const saveOrder = function ({ commit, state }, item) {
  commit(types.SET_CURRENT_ORDER, item);
  saveCurOrder(item);
};

export const saveCard = function ({ commit, state }, item) {
  commit(types.SET_CURRENT_CARD, item);
  saveCurCard(item);
};

export const saveInvoiceType = function ({ commit, state }, str) {
  commit(types.SET_INVOICE_TYPE, str);
  saveInvoice(str);
};

export const SET_CCB_DISCOUNT = function ({ commit, state }, str) {
  commit(types.SET_CCB_DISCOUNT, str);
  sessionStorage.setItem("ccbDiscount", str);
};

// export const saveOrderType = function ({ commit, state }, str) {
//   commit(types.SET_CURRENT_ORDER_TYPE, str);
//   saveCurOrderType(str);
// }
